// extracted by mini-css-extract-plugin
export default {"root":"ErrorMessage_root__M7GmL","light":"ErrorMessage_light__vguqa","text":"ErrorMessage_text__HMD3h"};